import { TInitialState, TPopupGroupState } from '@r1-frontend/entities/ConnectDomruPopup/context/initialState';

export const getView = (state: TInitialState): TPopupGroupState => state.view;
